const Quotes = () => {
  return (
    <div data-testid="quotes-page">
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '2rem' }}>Quotes</h1>
      <div className="card">
        <p>Quotes feature coming soon...</p>
      </div>
    </div>
  );
};

export default Quotes;
